import 'css-chunksrc/client/pages/zonesPage/projectsPage/styles.scss';export default {
  "projectsPage": "_projectsPage_130k8_1",
  "content": "_content_130k8_10",
  "main": "_main_130k8_18",
  "header": "_header_130k8_27",
  "row": "_row_130k8_35",
  "contextualMenuIcon": "_contextualMenuIcon_130k8_39",
  "wbsConfigurationIcon": "_wbsConfigurationIcon_130k8_47",
  "addZoneButton": "_addZoneButton_130k8_57",
  "wrapper": "_wrapper_130k8_61",
  "zoneInfo": "_zoneInfo_130k8_79",
  "iconBox": "_iconBox_130k8_89",
  "avatar": "_avatar_130k8_97",
  "icon": "_icon_130k8_89",
  "name": "_name_130k8_111",
  "opened": "_opened_130k8_117",
  "list": "_list_130k8_121",
  "item": "_item_130k8_128",
  "zones": "_zones_130k8_136",
  "exportButton": "_exportButton_130k8_145"
};